import Module from '@/store/resource/common/module';
import CustomReports from '@/store/resource/customReports';

let module = new Module(new CustomReports());

module.state.loadedClasses = [];
module.state.listFilter = {
  owners: [],
  createdAfter: null,
  createdBefore: null,
};

module.add('getters', {
  allByClass(state) {
    return (reportClass) => {
      if (!reportClass) return [];
      return state.all.filter((r) => r.class === reportClass);
    };
  },
  listFilter(state) {
    return state.listFilter;
  },
  filteredByClass(state) {
    return (reportClass, search = '') => {
      if (!reportClass) return [];
      const { owners, createdAfter, createdBefore } = state.listFilter;
      const afterTs = createdAfter ? new Date(createdAfter).getTime() : null;
      const beforeTs = createdBefore ? new Date(createdBefore).getTime() : null;
      const q = search.toLowerCase();

      return state.all.filter((r) => {
        if (r.class !== reportClass) return false;
        if (q && !(r.title || '').toLowerCase().includes(q)) return false;
        if (owners?.length && !owners.includes(r.user_id)) return false;
        if (afterTs || beforeTs) {
          const ts =
            r.created_at > 9999999999 ? r.created_at : r.created_at * 1000;
          if (afterTs && ts < afterTs) return false;
          if (beforeTs && ts > beforeTs) return false;
        }
        return true;
      });
    };
  },
  isClassLoaded(state) {
    return (reportClass) => state.loadedClasses.includes(reportClass);
  },
});

module.add('mutations', {
  setClassLoaded(state, reportClass) {
    if (!state.loadedClasses.includes(reportClass)) {
      state.loadedClasses.push(reportClass);
    }
  },
  setListFilter(state, filter) {
    state.listFilter = { ...state.listFilter, ...filter };
  },
});

module.add('actions', {
  async loadByClass({ dispatch, commit, getters }, reportClass) {
    if (getters.isClassLoaded(reportClass)) return;
    try {
      await dispatch('loadSome', { params: { class: reportClass } });
      commit('setClassLoaded', reportClass);
    } finally {
      commit('loaded', true);
    }
  },
});

export default module.create();
